import axios from 'axios'

const mail = {
  namespaced: true,
  state: {
    mail: {
      Nome: '',
      Email: '',
      Telefone: '',
      Mensagem: ''
    }
  },
  mutations: {
    setMail: (state, data) => (state.mail = data)
  },
  actions: {
    setMail: ({ commit }, payload) => {
      commit('setMail', payload)
      axios.post('https://menon.ao/home/sendemail', payload)
        .then(response => {
          commit('setMail', response.data)
        })
        .catch(error => alert(error))
    }
  },
  getters: {
    getMail: state => state.mail
  }
}

export default mail
